'use strict';
import moment from 'moment-timezone';

const errorSvg = require('../images/error.svg');

angular.module('docketbook').
  controller('dashboardController', function (userService, billingService, addressBookService, docketService, $routeParams, jobService, orderService, $rootScope, $scope, $stateParams, $state, Restangular, $location, accessControl, currentUser, uuid, $timeout) {
    mixpanel.track("Opened Dashboard Desktop");


    $scope.newOrganisation = {};
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.organisations = accessControl.allowedOrganisations();
    $scope.hasSampleCompany = accessControl.hasSampleCompany();
    $scope.userCanDoAction = userService.userCanDoAction;
    $scope.apiPath = DOCKETBOOK_API_URL;
    $scope.unverifiedEmail = undefined;
    $scope.unverifiedPhone = undefined;
    //$scope.orgUnitSelected = [];
    $scope.welcomeMessage = "It's looking rather empty in here..";
    $scope.allTimezones = moment.tz.names();
    $scope.errorSvgImagePath = errorSvg;
    $scope.onboardingSessions = accessControl.onboardingSessions();
    $scope.allGroups = []


    if ($scope.currentOrgGroup) {
      mixpanel.track("Opened Org Group Dashboard");
      var groupsCount = 0;
      for (var i = 0; i < $scope.currentOrg.groups.length; i++) {
        if ($scope.currentOrg.groups[i].parent == $scope.currentOrgGroup.id && $scope.currentOrg.groups[i].active) {
          groupsCount += 1;
        }
      }
      if (groupsCount > 0) {
        $scope.hasGroups = true;
      } else {
        $scope.hasGroups = false;
      }

      $scope.allGroups = $scope.currentOrg.groups.filter(group => group.active)

      localStorage.setItem(`orgGroup-${currentUser.id}`, JSON.stringify({ orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id }))
    } else {
      $scope.hasGroups = false;
    }

    // Check for mobile/desktop mode
    $scope.$on('$viewContentLoaded', function () {
      if ($("#mainTemplateOuter").length > 0) {
        $("body").addClass('dark');
      }
    });

    // CHECK IF THIS USER ONLY HAS 1 COMPANY AND SEND THEM STRAIGHT THERE
    if ($state.current.name == 'main.dashboard') {
      if ($scope.organisations.length == 1) {
        $state.go('main.groupDashboard', { orgId: $scope.organisations[0].id, groupId: 'home' });
      }
    }

    //if the user doesn't have any verified principals, when we should display a banner
    //telling them their account is unverified
    if ($scope.currentUser.unverifiedPrincipals) {
      const unverifiedOverlap = $scope.currentUser.emailAddresses.filter((address) => {
        return $scope.currentUser.unverifiedPrincipals.indexOf(address) === -1;
      })
      if (unverifiedOverlap.length === 0) {
        //all their principals are waiting validation - show a banner appropiate for the first principal
        //i.e. email principal requires them to check their email inbox
        //phone number requires them to visit the my account area to validate
        const target = $scope.currentUser.unverifiedPrincipals[0];
        if (target.indexOf('users.docketbook.io') !== -1) {
          //its a phone number
          $scope.unverifiedPhone = "0" + target.split('@')[0].substring(3);
        } else {
          $scope.unverifiedEmail = target;
        }
      }
    }


    $scope.goToMyDocketbook = function() {
      $state.go('main.dockets')
    }

    $scope.goToOnbboardingSession = function (session) {
      window.location.href = `/onboarding/${session == undefined ? '' : session.id}`
    }


    $scope.showWaitToBeInvitedModal = function() {
      $('#waitToBeInvitedModal').fadeIn(100)
    }

    $scope.closeWaitToBeInvitedModal = function() {
      $('#waitToBeInvitedModal').fadeOut(100)
    }


    $scope.goTo = function (view) {
      var currentPath = $location.path();
      if (currentPath == "/" + view) {
        $scope.mobileNav = false;
      }
      $location.path(view);
    }

    $scope.docketCount = 10;
    $scope.orderCount = 20;
    $scope.jobCount = 30;

    $scope.currentNavItem = "page1";

    /*************************/
    /***** Intercom JS API  **/
    /*************************/

    $scope.openIntercom = function () {
      window.FreshworksWidget('open', 'ticketForm')
    }

    $scope.xeroAuth = function () {
      //href="/v1/organisations/{{currentOrg.id}}/groups/{{currentOrgGroup.id}}/xero/auth"
      window.location = "/v1/organisations/" + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/xero/auth?source=" + btoa(window.location.hash);
    }

    /*****************************************/
    /***** Standard Permission Functions *****/
    /*****************************************/

    /* F/E Permission Checking */
    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    /*****************************/
    /* Create a new organisation */
    /*****************************/

    $scope.newCompany = function (isSampleCompany) {
      if (isSampleCompany) {
        mixpanel.track("Clicked Create New Demo Company");
      } else {
        mixpanel.track("Clicked Create New Company");
      }
      $scope.createNewCompanyFromParent(isSampleCompany, function (newOrg) {
        if (newOrg != null) {
          $state.go('main.groupDashboard', { orgId: newOrg.id });
          if (isSampleCompany) {
            mixpanel.track("Created New Demo Company");
          } else {
            mixpanel.track("Created New Company");
          }
        } else {
          if (isSampleCompany) {
            mixpanel.track("Abandoned Create New Demo Company");
          } else {
            mixpanel.track("Abandoned Create New Company");
          }
          accessControl.refreshAndGetAllowedOrganisations(function (orgs) {
            $scope.organisations = orgs;
          });
        }
      });
    }

    /*** Select PLan ***/
    $scope.expiredSelectPlan = function () {
      $scope.selectPlan(function () {
        billingService.getOrganisationBilling($scope.currentOrg.id, function (billingDetails) {
          $scope.billingDetails = billingDetails;
          if (billingDetails.currentPlanId == null) {
            $scope.currentOrg.trialExpired = true;
          } else {
            $scope.currentOrg.trialExpired = false;
          }
        });
      },
        null,
        'select plan modal - view - from expired plan'
      );
    }
    if ($scope.currentOrg) {
      $scope.currentOrg.billingIssue = false;
    }
    if ($scope.currentOrg && $scope.currentOrg.accessAllowed == false && $scope.currentOrg.accessReason == 'trialEnded') {
      billingService.getOrganisationBilling($scope.currentOrg.id, function (billingDetails) {
        $scope.billingDetails = billingDetails;
        if (billingDetails.currentPlanId == null) {
          $scope.currentOrg.trialExpired = true;
        } else {
          $scope.currentOrg.trialExpired = false;
        }
      }, function (err) {
        $scope.currentOrg.trialExpired = true;
      });
    } else if ($scope.currentOrg && $scope.currentOrg.accessAllowed == false && $scope.currentOrg.accessReason == 'billingIssue') {
      $scope.currentOrg.billingIssue = true;
    }

    /************************/
    /***** SUMMARY DATA *****/
    /************************/

    $scope.getInteractionSummary = function (dockets) {
      $scope.interactionSummary = {};
      $scope.interactionSummary.loading = true;

      if (dockets.length == 0) {
        $scope.interactionSummary.disabled = true;
      } else {
        $scope.interactionSummary.disabled = false;
      }

      var ids = [];
      for (var i = 0; i < dockets.length; i++) {
        ids.push(dockets[i].id);
      }

      var params = {};
      params.ids = ids.join(',');

      if (dockets && dockets.length > 0) {
        docketService.getDockets(params, function (docketsList) {
          $scope.setupSummaryMap(docketsList);
        }, function (err) {
          $scope.interactionSummary.loading = false;
          $scope.interactionSummary.error = "Error loading interactions";
        });
      } else {
        $scope.interactionSummary.loading = false;;
      }
    }

    $scope.resetSummaryData = function () {
      $scope.ordersSummary = {};
      $scope.ordersSummary.loading = true;
      $scope.ordersSummary.total = 0;
      $scope.ordersSummary.data = { 'draft': 0, 'sent': 0, 'accepted': 0, 'rejected': 0 };

      $scope.jobsSummary = {};
      $scope.jobsSummary.loading = true;
      $scope.jobsSummary.total = 0;
      $scope.jobsSummary.assigneesTotal = 0;
      $scope.jobsSummary.data = { 'sent': 0, 'accepted': 0, 'rejected': 0, 'pending': 0 };

      $scope.docketsSummary = {};
      $scope.docketsSummary.loading = true;
      $scope.docketsSummary.total = 0;
      $scope.docketsSummary.data = { 'draft': 0, 'sent': 0, 'accepted': 0, 'rejected': 0 };

      $scope.notificationsSummary = {};
      $scope.notificationsSummary.loading = true;
      $scope.notificationsSummary.notifications = [];

      $scope.interactionSummary = {};
      $scope.interactionSummary.loading = true;
      $scope.getInteractionSummary([]);
    }

    $scope.resetSummaryData();

    $scope.getDocketsSummaryData = function () {
      if (!(accessControl.userHasPermission('io.docketbook.ojdapi.getDocket') || accessControl.userHasPermission('io.docketbook.ojdapi.getMyDocket'))) {
        $scope.docketsSummary.hide = true;
        $scope.docketsSummary.loading = false;
        $scope.docketsSummary.error = "No Access To Dockets";
        return;
      }
      var params = {};
      params.date = moment().format('YYYY-MM-DD');

      docketService.getDockets(params, function (docketsList) {
        var docketsByStatus = { 'draft': 0, 'sent': 0, 'accepted': 0, 'rejected': 0, 'closed': 0 };
        for (var i = 0; i < docketsList.length; i++) {
          if (docketsByStatus[docketsList[i].status] != null) {
            docketsByStatus[docketsList[i].status] += 1;
          }
        }
        $scope.docketsSummary.total = docketsList.length;
        $scope.docketsSummary.data = docketsByStatus;
        $scope.docketsSummary.loading = false;
        var listToFetch = docketsList;
        if (docketsList.length > 100) {
          listToFetch = listToFetch.slice(0, 99);
        }
        $scope.getInteractionSummary(listToFetch);
      }, function (err) {
        $scope.docketsSummary.loading = false;
        $scope.docketsSummary.error = "Loading Error";
      });
    }

    $scope.getDocketsSummaryData();

    $scope.getJobsSummaryData = function () {
      if (!(accessControl.userHasPermission('io.docketbook.ojdapi.getJob') || accessControl.userHasPermission('io.docketbook.ojdapi.getMyJob'))) {
        $scope.jobsSummary.hide = true;
        $scope.jobsSummary.loading = false;
        $scope.jobsSummary.error = "No Access To Jobs";
        return;
      }
      var params = {};
      params.activeDate = moment().format('YYYY-MM-DD');

      jobService.getJobs(params, function (jobsList) {
        var jobsByStatus = { 'sent': 0, 'accepted': 0, 'rejected': 0, 'assigned': 0, 'completed': 0 };
        for (var i = 0; i < jobsList.length; i++) {
          if (jobsList[i].status == 'sent') {
            jobsByStatus.sent += 1;
          }
          if (jobsList[i].assignees) {
            for (var j = 0; j < jobsList[i].assignees.length; j++) {
              jobsByStatus[jobsList[i].assignees[j].status] += 1;
            }
          }
        }
        jobsByStatus['pending'] = jobsByStatus['assigned'];
        $scope.jobsSummary.total = jobsList.length;
        $scope.jobsSummary.data = jobsByStatus;
        $scope.jobsSummary.assigneesTotal = 0;
        $scope.jobsSummary.loading = false;
      }, function (err) {
        $scope.jobsSummary.loading = false;
        $scope.jobsSummary.error = "Loading Error";
      });
    }

    $scope.getJobsSummaryData();

    $scope.getOrdersSummaryData = function () {
      if (!accessControl.userHasPermission('io.docketbook.ojdapi.getOrder')) {
        $scope.ordersSummary.hide = true;
        $scope.ordersSummary.loading = false;
        $scope.ordersSummary.error = "No Access To Orders";
        return;
      }
      var params = {};
      params.activeDate = moment().format('YYYY-MM-DD');

      orderService.getOrders(params, function (ordersList) {
        var ordersByStatus = { 'draft': 0, 'sent': 0, 'accepted': 0, 'rejected': 0 };
        for (var i = 0; i < ordersList.length; i++) {
          if (ordersByStatus[ordersList[i].status] != null) {
            ordersByStatus[ordersList[i].status] += 1;
          }
        }
        $scope.ordersSummary.total = ordersList.length;
        $scope.ordersSummary.data = ordersByStatus;
        $scope.ordersSummary.loading = false;
      }, function (err) {
        $scope.ordersSummary.loading = false;
        $scope.ordersSummary.error = "Loading Error";
      });
    }

    $scope.getOrdersSummaryData();

    $scope.setupSummaryMap = function (dockets) {
      var interactionMarkers = [];
      var centerPos = {};
      var bounds = new google.maps.LatLngBounds();
      var mapDiv = "#fullInteractionMap";
      // Show Interactions Map
      var options = {
        disableDefaultUI: false
      };
      var map = new google.maps.Map($(mapDiv).get(0), options);
      var places = new google.maps.places.PlacesService(map);

      var infowindow = new google.maps.InfoWindow({
        content: "holding.."
      });

      for (var k = 0; k < dockets.length; k++) {
        var docket = dockets[k];
        if (docket.resources) {
          var lastInteraction = null;
          for (var i = 0; i < docket.resources.length; i++) {
            for (var j = 0; j < docket.resources[i].interactions.length; j++) {
              var thisInteraction = docket.resources[i].interactions[j];
              if (thisInteraction.lat && thisInteraction.long && thisInteraction.createdAt) {
                if (lastInteraction == null) {
                  lastInteraction = thisInteraction;
                } else if (moment(thisInteraction.createdAt).isAfter(moment(lastInteraction.createdAt))) {
                  lastInteraction = thisInteraction;
                }
              }
            }
          }

          if (lastInteraction != null && lastInteraction.lat && lastInteraction.long) {
            centerPos = { lat: lastInteraction.lat, lng: lastInteraction.long };
            var htmlString = "";
            if (docket.customerContact) {
              htmlString += '<p>Customer: ' + docket.customerContact.displayName + '</p>';
            }
            htmlString += '<p>Operator: ' + docket.authorName + '</p>';
            if (lastInteraction.resource) {
              htmlString += '<p>Resource: ' + lastInteraction.resource.name + '</p><p>Line Type: ' + lastInteraction.interactionName + '<p>Quantity: ' + lastInteraction.quantity + ' ' + lastInteraction.resource.uom.abbreviation + '</p>';
            }
            htmlString += '<p>' + moment(lastInteraction.createdAt).tz(docket.timezone).format('DD/MM/YY hh:mm a') + '</p>';
            var newMapMarker = new google.maps.Marker({
              position: centerPos,
              title: 'Line Created Here',
              animation: google.maps.Animation.DROP,
              label: 'L',
              html: htmlString
            });
            google.maps.event.addListener(newMapMarker, 'click', function () {
              infowindow.setContent(this.html);
              infowindow.open(map, this);
            });
            var loc = new google.maps.LatLng(centerPos.lat, centerPos.lng);
            bounds.extend(loc);
            interactionMarkers.push(newMapMarker);
          }
        }
      }

      map.fitBounds(bounds);
      map.panToBounds(bounds);
      for (var i = 0; i < interactionMarkers.length; i++) {
        interactionMarkers[i].setMap(map);
      }
      $scope.interactionSummary.loading = false;
    }

    /***************************/
    /****** NOTIFICATIONS ******/
    /***************************/

    $scope.getOrgNotifications = function () {
      var notifications = [];

      /**** Contact Share Messages ****/
      addressBookService.getContactShares(null, function (contactSharesList) {
        $scope.injectContactShareNotifications(contactSharesList, notifications, function () {
          $scope.notificationsSummary.loading = false;
          $scope.notificationsSummary.notifications = notifications;
        });
      });
    }

    $scope.deleteSession = function (event, session) {
      event.stopPropagation()
      accessControl.deleteSession(session,
        function () {
          $scope.onboardingSessions = _.without($scope.onboardingSessions, session)
        }
      )
    }

    /***** New Group Modal ******/
    $scope.newOrgGroup = function () {
      $state.go('companySettings.groups', { orgId: $scope.currentOrg.id })

      /*mixpanel.track("Clicked Create New Org Group");
      $("#newGroupModal").fadeIn(100);
      $scope.newGroup = {};
      $scope.newGroup.timezone = $scope.currentOrgGroup.timezone;
      $scope.createNewGroupFromParent($scope.currentOrgGroup, function(newGroupCreated) {
        if ( newGroupCreated != null ) {
          mixpanel.track("Created New Org Group");
          accessControl.refreshAndGetAllowedOrganisations(function(orgsList) {
            $scope.allOrganisations = orgsList;
            $state.go('main.groupDashboard', {orgId: $scope.currentOrg.id, groupId: newGroupCreated.id});
          });
        } else {
          mixpanel.track("Abandoned New Org Group");
        }
      });*/
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/dashboard.js